export const SEARCH_PERSON_SELECT_LIST = null;
export const GET_TERMS_AND_CONDITIONS_LIST = null;
export const VERIFIED_DIALOG_OPEN = null;
export const VERIFIED_DIALOG_CLOSE = null;
export const SUSPEND_DIALOG_OPEN = null;
export const SUSPEND_DIALOG_CLOSE = null;
export const FETCHED_ALL_NOTIFICATIONS = null;
export const MARK_AS_READ = null;
export const GET_FINE_TRANSACTION_HISTORY_LIST = null;
export const CHECK_SPONSORSHIP_AVAILABILITY = null;
export const DELETE_ACCOUNT = null;
